import { render, staticRenderFns } from "./RecordAd.vue?vue&type=template&id=3e5c65b3&"
import script from "./RecordAd.vue?vue&type=script&lang=js&"
export * from "./RecordAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports